









































































































































































































































import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Cidea extends Vue {
  // 背景图样式文案
  list = {
    style: {
      "background-image": `url(${require("@/zh-website/src/assets/banner_certification.png")})`,
      height: "493px"
    },
    font1: "人工智能专业建设",
    font2: "",
    font3: "",
    font4: "全场景、端到端",
    font5: "培养智能时代智慧人才",
    button: ""
  };
}
